import React from 'react';
import { MapPin } from 'lucide-react';
import { guessAudioMime } from './chatUtils';

function MessageBubble({ message, mediaType }) {
  const isOutbound = message.direction === 'outbound';
  
  const bubbleClasses = `
    max-w-[78%] rounded-xl p-3 shadow-sm mb-2
    ${isOutbound 
      ? 'bg-brand-primary text-white rounded-tr-sm ml-auto' 
      : 'bg-slate-800 text-white rounded-tl-sm mr-auto'
    }
  `;

  const containerClasses = `
    flex
    ${isOutbound ? 'justify-end' : 'justify-start'}
  `;

  return (
    <div className={containerClasses}>
      <div className={bubbleClasses}>
        {/* Content based on media type */}
        {mediaType === 'location' ? (
          <div>
            <div className="flex items-center gap-2 font-semibold mb-2 font-montserrat">
              <MapPin className="w-4 h-4" />
              Ubicación
            </div>
            <a
              href={`https://www.google.com/maps?q=${message.latitude},${message.longitude}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-gold hover:underline text-sm font-montserrat"
            >
              {message.content || `${message.latitude}, ${message.longitude}`}
            </a>
          </div>
        ) : mediaType === 'audio' ? (
          <div>
            <div className="font-semibold mb-2 text-sm font-montserrat">
              🎤 Mensaje de voz
            </div>
            <audio
              controls
              preload="metadata"
              className="w-full mb-2"
            >
              <source src={message.media_url} type={guessAudioMime(message.media_url)} />
              Tu navegador no puede reproducir este audio.
            </audio>
            <a
              href={message.media_url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-brand-gold hover:underline font-montserrat"
            >
              Descargar audio
            </a>
            {message.content && (
              <div className="mt-2 text-sm opacity-90 font-montserrat">{message.content}</div>
            )}
          </div>
        ) : mediaType === 'image' ? (
          <div>
            <div className="rounded-lg overflow-hidden mb-2 bg-slate-900">
              <img
                src={message.media_url}
                alt="Imagen enviada"
                className="w-full h-auto block"
                onError={(e) => {
                  console.warn('Image failed to load:', message.media_url);
                  e.target.style.display = 'none';
                }}
              />
            </div>
            {message.content && (
              <div className="text-sm opacity-95 font-montserrat">{message.content}</div>
            )}
          </div>
        ) : (
          <div className="text-sm leading-relaxed whitespace-pre-wrap font-montserrat">
            {message.content}
          </div>
        )}

        {/* Timestamp */}
        <div className="flex justify-end mt-1 text-xs opacity-70 font-montserrat">
          {new Date(message.timestamp).toLocaleTimeString([], { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}
        </div>
      </div>
    </div>
  );
}

export default MessageBubble;